export const mapClientSocialSecurityNumber = (sin: string | null | undefined): string => {
  if (!sin) {
    return '';
  }
  return sin.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
};
